import * as React from 'react';
import { LazyLoadComponentWrapper } from '@components/lazy-load/lazy-load-component-wrapper';
import { PageLoadingIndicator } from '@components/page-loading-indicator';

const { lazy } = React;
const UnifiedTrackViewComponent = lazy(() => import(/* webpackChunkName:"srm-unified-track-view" */'./index'));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const UnifiedTrackView = (props) => {
    return (
        <LazyLoadComponentWrapper
            fallback={null}
            errorIndicator={<PageLoadingIndicator error={true} />}>
            <UnifiedTrackViewComponent />
        </LazyLoadComponentWrapper>
    );
};
